<template>
  <div class="hotelPhoto">
    <figure class="hotelPhotoFigure">
      <img :src="thumbnailImage" />
    </figure>
    <tk-link class="hotelPhotoBtn" @click="showPhotoModal = true">
      <tk-icon name="photo_gallery"></tk-icon>
    </tk-link>

    <tk-hotel-modal
      v-if="showPhotoModal"
      width="100%"
      height="100%"
      :click-to-close="true"
      @closed="showPhotoModal = false"
    >
      <section id="modalGallery" class="hotelModal">
        <div class="modalHeader">
          <tk-link class="modalBack" @click="showPhotoModal = false">
            <tk-svg-icon class="icoBack" icon="prev" />
            戻る
          </tk-link>
        </div>

        <div class="hotelModalFlex">
          <div
            class="hotelModalRight hotelGalleryShow"
            :class="{ imageOpen: showImageOnSp }"
          >
            <tk-link class="imageBg" @click="showImageOnSp = false">
              <tk-svg-icon class="icoClose" icon="close" />
            </tk-link>

            <swiper ref="gallerySwiper" :options="swiperOption">
              <swiper-slide
                v-for="image in imageList"
                :key="image"
                class="hotelRoomPhotoItem"
              >
                <img :src="image" @error="setAltImage" />
              </swiper-slide>
              <div slot="pagination" class="swiper-pagination"></div>
            </swiper>
          </div>

          <div class="hotelModalLeft">
            <ul class="hotelGalleryList">
              <li v-for="(image, index) in imageList" :key="image">
                <img
                  :src="image"
                  @click="selectImage(index + 1)"
                  @error="setAltImage"
                />
              </li>
            </ul>
          </div>
        </div>

        <div class="modalFooter">
          <tk-link class="hotelBtnMini" @click="showPhotoModal = false">
            閉じる
          </tk-link>
        </div>
      </section>
    </tk-hotel-modal>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import noImage from '@ota-frontend/shared-assets/images/common/noimage.jpg'
import TkIcon from '../../atoms/TkIcon/TkIcon.vue'
import TkSvgIcon from '../../atoms/TkIcon/TkSvgIcon.vue'
import TkLink from '../../atoms/TkLink/TkLink.vue'
import TkHotelModal from '../../atoms/TkGlobalModal/TkHotelModal.vue'

export default {
  name: 'TkHotelGallery',
  components: {
    TkIcon,
    TkHotelModal,
    Swiper,
    SwiperSlide,
    TkSvgIcon,
    TkLink,
  },
  props: {
    thumbnailImage: {
      type: String,
      required: true,
    },
    imageList: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      showPhotoModal: false,
      showImageOnSp: false,
      swiperOption: {
        speed: 1000,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
      },
      noImage,
    }
  },
  methods: {
    selectImage(index) {
      this.$refs.gallerySwiper.$swiper.slideTo(index)
      this.showImageOnSp = true
    },
    setAltImage(event) {
      event.target.src = noImage
    },
  },
}
</script>

<style lang="scss">
@import '@ota-frontend/ui/src/scss/components/TkHotelGallery.scss';
</style>
